import { Link2 } from "lucide-react";
import { PageHeader } from "@/components/Layout/PageHeader";
import { SocialAccountsManager } from "./SocialAccountsManager";

export function SocialAccountsPage() {
  return (
    <div>
      <PageHeader
        icon={Link2}
        title="Connected Accounts"
        description="Connect and manage your social media accounts across Instagram, Twitter/X, Facebook, LinkedIn, Threads, YouTube, and TikTok. Conorbit syncs follower counts and engagement data automatically."
      />
      <SocialAccountsManager showHeader={false} />
    </div>
  );
}
